@use '~@frontrow/console/css/variables.scss';

.deleteLicenseDetailContainer {
  display: flex;
  align-items: center;
  font-size: variables.$font-size-md;
}

.deleteLicenseButtonContainer {
  display: flex;
  justify-content: flex-end;
  padding: variables.$std-padding-md;
}

.deleteLicenseDetail {
  margin-right: variables.$std-margin-lg;
}

.schoolNameLabel {
  font-size: variables.$font-size-md;
}

.deleteLicenseButton {
  margin-left: variables.$std-margin-md;
}
